import { useStores } from '@littlebird/sdk';
import { useQueries, useQueryClient } from '@tanstack/react-query';

import {
  artifactPolicy,
  getFileVersionKey,
} from '@/features/artifacts/artifact-presentation';
import { artifactBodyQueryOptions } from '@/features/artifacts/artifact.query';
import { useHydratedFiles } from '@/hooks/useHydratedFile';
import { isCanvasFile } from '@/utils/files';

export const useCanvasOnlyActionCardIds = (fileIds: string[]) => {
  'use no memo';

  const { files: filesStore } = useStores();
  const queryClient = useQueryClient();
  const hydratedFiles = useHydratedFiles(fileIds);
  const canvasFiles = hydratedFiles.flatMap((hydrated) =>
    hydrated.status === 'ready' &&
    isCanvasFile(hydrated.file.contentType, hydrated.file.filename)
      ? [hydrated.file]
      : []
  );
  const bodies = useQueries({
    queries: canvasFiles.map((file) =>
      artifactBodyQueryOptions(
        queryClient,
        getFileVersionKey(file),
        () => filesStore.getFileUrl(file),
        'canvas',
        artifactPolicy(file).byteCap
      )
    ),
  });

  const canvasOnlyLocalIds = new Set<number>();
  for (const body of bodies) {
    const parseResult =
      body.data?.outcome === 'ready' ? body.data.canvas : undefined;
    if (!parseResult?.success) continue;
    for (const reference of parseResult.canvasPackage.actionCards ?? []) {
      if (reference.placement === 'canvas') {
        canvasOnlyLocalIds.add(reference.localId);
      }
    }
  }
  return {
    canvasOnlyLocalIds,
    isLoading:
      hydratedFiles.some(({ status }) => status === 'loading') ||
      bodies.some(({ isPending }) => isPending),
  };
};
